export default __webpack_public_path__ + "static/media/ProductSans-Bold.1b1b4ad4.svg";